/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

/**
 * Továrna na vlákna zobrazující obsah.
 * @implements {Destroyable}
 * @implements {EventBus}
 */
class ViewerThreadFactory {
  /**
   * Vytvoří instanci.
   * @param {Class.<ViewerThread>} ViewerThread Konstruktor pro vlákna.
   * @param {ViewerDelayerFactory} delayerFactory Továrna na správce zpoždění.
   * @param {Logger} logger
   * @param {NetworkListener} networkListener
   * @param {ViewerSlideFactory} slideFactory Továrna na slajdy pro přehrávače obsahu.
   * @param {Object} [opts={}] Nepovinné parametry.
   * @param {number} [opts.loadLimit] Maximální počet médií, které se přeskočí při pokusu o přednačtení následujícího slajdu.
   * @returns {ViewerThreadFactory} Nová instance.
   */
  constructor(
    ViewerThread,
    delayerFactory,
    logger,
    networkListener,
    slideFactory,
    { loadLimit } = {}
  ) {
    this.ViewerThread = ViewerThread;
    this.delayerFactory = delayerFactory;
    this.loadLimit = loadLimit;
    this.logger = logger;
    this.networkListener = networkListener;
    this.slideFactory = slideFactory;
  }

  /**
   * Vytvoří nové vlákno zobrazující obsah.
   * @param {HTMLElement} el Rodičovský eLement, do kterého se vlákno vykresluje.
   * @param {ScheduleStrategy} scheduleStrategy Strategie přehrávání obsahu, který řídí, co vlákno zobrazuje.
   * @returns {ViewerThread} Vytvořené vlákno.
   */
  create(el, scheduleStrategy) {
    return new this.ViewerThread(
      this.delayerFactory,
      el,
      this.logger,
      this.networkListener,
      scheduleStrategy,
      this.slideFactory,
      { loadLimit: this.loadLimit }
    );
  }
}

export default ViewerThreadFactory;
